import styled from 'styled-components';

import { GenderSelector } from 'components/modules/Insurance/components/GenderSelector/GenderSelector';
import { FullNameInputs as BaseFullNameInputs } from 'components/modules/Insurance/components/FullNameInputs/FullNameInputs';

export const Genders = styled(GenderSelector)`
  grid-column: 1 / 3;
`;

export const FullNameInputs = styled(BaseFullNameInputs)`
  grid-column: 1 / 3;
`;

export * from 'components/modules/Insurance/Insurance.styles';
